import React, { useEffect, useState } from 'react'
import { Grid, CircularProgress, Container, Paper, useTheme, Typography, Checkbox, Chip, IconButton, useMediaQuery } from '@material-ui/core'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import { useParams, useHistory } from 'react-router-dom'
import { getGameById } from '../../api'
import { useStore } from '../../context/Context'
import useStyles from './styles'

const DetailMovie = () => {
  const { id } = useParams()
  const classes = useStyles()
  const theme = useTheme()
  const history = useHistory()
  const matchSM = useMediaQuery(theme.breakpoints.down('sm'))
  const { isLoading, setIsLoading } = useStore()
  const [data, setData] = useState([])

  useEffect(() => {
    const fetchDataById = async (id) => {
      setIsLoading(true)
      try {
        const response = await getGameById(id)
        setData([response.data])
      } catch (error) {
        console.log(error)
      }
      setIsLoading(false)
    }
    fetchDataById(id)
  }, [id, setIsLoading, setData])

  if (isLoading || !data.length) return (
    <Grid container justifyContent="center" alignItems="center" className={classes.loading}>
      <CircularProgress />
    </Grid>
  )

  return (
    <Container>
      <IconButton className={classes.chevron} onClick={() => history.goBack()}>
        <ChevronLeftIcon color="action" />
      </IconButton>
      <Grid container component={Paper} direction={matchSM ? 'column' : 'row'} className={classes.container} elevation={0} wrap={matchSM ? undefined : 'nowrap'}>
        <Grid item md={matchSM ? undefined : 6}>
          <div style={{
            backgroundImage: `url(${data[0].image_url})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            width: '100%',
            height: 483,
            borderRadius: theme.shape.borderRadius
          }} />
        </Grid>
        <Grid item container style={matchSM ? { marginTop: theme.spacing(3) } : { marginLeft: theme.spacing(3) }}>
          <Grid item container direction="column" spacing={1}>
            <Grid item container alignItems="center" className={classes.title}>
              <Grid item>
                <Typography variant="h4">{data[0].name}</Typography>
              </Grid>
            </Grid>
            <Grid item container alignItems="center" className={classes.genre}>
              <Typography variant="body1" color="textSecondary" className={classes.pushRight}>Genre:</Typography>
              <div style={{ display: 'inline-flex', gap: '1em', flexWrap: 'wrap' }}>
                {data[0].genre?.split(',').map(genre => genre.trim()).map((genre, index) => (
                  <Chip color="primary" key={index.toString()} label={genre} style={{ cursor: 'pointer', color: 'white' }} />
                ))}
              </div>
            </Grid>
            <Grid item container alignItems="center">
              <Typography variant="body1" color="textSecondary" className={classes.pushRight}>Released in:</Typography>
              <Typography variant="body2" color="textPrimary" style={{ fontWeight: 700 }}>{data[0].release}</Typography>
            </Grid>
            <Grid item container alignItems="center" className={classes.genre}>
              <Typography variant="body1" color="textSecondary" className={classes.pushRight}>Platform:</Typography>
              <div style={{ display: 'inline-flex', gap: '1em', flexWrap: 'wrap' }}>
                {data[0].platform?.split(',').map(pf => pf.trim()).map((pf, index) => (
                  <Chip color="secondary" key={index.toString()} label={pf} style={{ cursor: 'pointer', color: 'white' }} />
                ))}
              </div>
            </Grid>
            <Grid item container alignItems="center">
              <Grid item container alignItems="center" style={{ width: 'auto' }} className={classes.pushRight}>
                <Typography variant="body1" color="textSecondary" className={classes.pushRight}>Singleplayer: </Typography>
                <Checkbox
                  checked={true}
                  disableRipple
                  disableFocusRipple
                  style={{ cursor: 'default' }}
                  classes={{
                    root: data[0].singlePlayer ? classes.checkboxYes : classes.checkboxNo
                  }}
                  color="default"
                  indeterminate={data[0].singlePlayer ? false : true}
                />
              </Grid>
              <Grid item container alignItems="center" style={{ width: 'auto' }}>
                <Typography variant="body1" color="textSecondary" className={classes.pushRight}>Multiplayer: </Typography>
                <Checkbox
                  checked={true}
                  disableRipple
                  disableFocusRipple
                  style={{ cursor: 'default' }}
                  classes={{
                    root: data[0].multiplayer ? classes.checkboxYes : classes.checkboxNo
                  }}
                  color="default"
                  indeterminate={data[0].multiplayer ? false : true}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid >
    </Container >
  )
}

export default DetailMovie
